// extracted by mini-css-extract-plugin
export default {"confirmMainBox":"LeadConfirm_confirmMainBox__lqbva","box":"LeadConfirm_box__MW222","privacyNotice":"LeadConfirm_privacyNotice__LPbRa"};